module.exports = __webpack_public_path__ + "static/media/red_content.6387b776.svg";